import {AxiosPromise} from 'axios';
import {injectable} from 'inversify';
import {HttpClient} from '../configs/axios.config';
import {ProductModel} from '../interfaces/models/ProductModel';
import {UserSubscription} from '../interfaces/models/UserSubscriptionModel';
import {Api} from './Api';

@injectable()
export class SubscriptionsApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    getSubscriptions(): AxiosPromise<UserSubscription[]> {
        return this.api.client.get<UserSubscription[]>(`/membership/subscriptions/`);
    }

    getProducts(): AxiosPromise<ProductModel[]> {
        return this.api.client.get<ProductModel[]>(`/products/list/`);
    }

    subscribeInApp(platform, productId, transactionReceipt): AxiosPromise<any> {
        return this.api.client.post<any>(`/membership/complete/`, { platform, productId, token: transactionReceipt });
    }

    subscribe(id, ds = false): AxiosPromise<{ url: string }> {
        return this.api.client.get(`/membership/subscribe/${id}${ds ? '?ds=1' : ''}`);
    }

    unsubscribe(orderId): AxiosPromise {
        return this.api.client.get(`/membership/unsubscribe/${orderId}`);
    }

}
